import {AiChatTipoEntita} from '../_models/ai-chat.model';
import {parametriArticolo, rottaArticolo, rottaEvento, rottaOrdine} from '../sinottico/_services/sinottico-link';

/**
 * Feature 160: URL della pagina di un'entità citata nella Chat AI. Le chiavi arrivano già verificate da
 * AgentApi (research R6); ordine, articolo ed evento riusano le rotte del Sinottico. `null` quando le chiavi
 * non bastano a costruire la rotta: il testo resta senza link.
 */
export function urlEntita(tipo: AiChatTipoEntita | string, chiavi: string[]): string | null {
  const [prima, seconda] = chiavi;
  if (!prima) return null;
  switch (tipo) {
    case 'ordine': return url(rottaOrdine(numero(prima), numero(seconda)));
    case 'articolo': return url(rottaArticolo(prima), parametriArticolo(prima));
    case 'evento': return url(rottaEvento(numero(prima)));
    case 'movimento': return url(['/movimenti'], {movimentoId: prima});
    case 'contenitore': return seconda ? url(['/contenitori', prima, seconda]) : null;
    case 'risorsa': return seconda ? url(['/risorse/detail', prima, seconda]) : null;
    case 'spedizione': return url(['/movimenti/spedizione', prima]);
    default: return null;
  }
}

function numero(valore?: string): number | null {
  const n = Number(valore);
  return valore && Number.isInteger(n) && n > 0 ? n : null;
}

function url(rotta: unknown[] | null, query?: Record<string, string> | null): string | null {
  if (!rotta) return null;
  const [base, ...segmenti] = rotta.map(String);
  const percorso = [base, ...segmenti.map(encodeURIComponent)].join('/');
  return query ? `${percorso}?${new URLSearchParams(query).toString()}` : percorso;
}
